<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-row
            class="mb-4">
            <v-col
              cols="12">
              <div
                class="d-flex align-center">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="30">
                    <v-img
                      contain
                      alt="amanata"  
                      :src="require('@/assets/image/grip_menu.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span
                    class="title black--text ml-2"
                    style="font-weight: 600;">
                    Pegawai
                  </span>
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
              md="6"
              class="pt-0">
              <ValidationProvider 
                name="Tempat Lahir" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  Tempat Lahir
                </div>

                <v-text-field
                  v-on:keyup.enter="save()"
                  
                  filled
                  rounded
                  dense

                  :color="set_color"
                  placeholder="Contoh. Yogyakarta"

                  hide-details

                  v-model="form.birthplace"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        {{ errors[0] }}
                      </v-tooltip>
                    </div>
                    
                    <div v-if="form.birthplace !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>

            <v-col
              cols="12"
              md="6"
              class="pt-0">
              <div>
                <div 
                  class="body-2 mb-2">
                  Tanggal Lahir
                </div>

                <v-menu
                  ref="birthdate"
                  min-width="290px"
                  max-width="290px"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  :close-on-content-click="false"
                  v-model="picker.birthdate">
                  <template v-slot:activator="{ on, attrs }">
                    <ValidationProvider 
                      name="Tanggal Lahir" 
                      v-slot="{ errors, valid }">
                      <v-text-field
                        v-on:keyup.enter="save()"
                        
                        readonly
                        filled
                        rounded
                        dense

                        :color="set_color"
                        placeholder="Contoh. 1992-08-20"

                        hide-details

                        clearable
                        @click:clear="form.birthdate = ''"

                        v-on="on"
                        v-bind="attrs"

                        v-model="form.birthdate"
                        :success="form.birthdate !== '' && valid"
                        :error-messages="errors"
                        required
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.birthdate !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </template>

                  <v-date-picker 
                    :color="set_color"
                    v-model="form.birthdate"
                    @input="picker.birthdate = false">
                  </v-date-picker>
                </v-menu>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
              md="6"
              class="mb-3">
              <ValidationProvider 
                name="Jenis Kelamin" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>

                  Jenis Kelamin
                </div>

                <v-select
                  v-on:keyup.enter="save()"
                  
                  filled
                  rounded
                  dense

                  :color="set_color"
                  placeholder="Contoh. Laki-Laki"

                  hide-details

                  :items="['Laki-Laki', 'Perempuan']"
                  :item-color="set_color"

                  v-model="form.gender"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        {{ errors[0] }}
                      </v-tooltip>
                    </div>
                    
                    <div v-if="form.gender !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>

            <v-col
              cols="12"
              md="6"
              class="mb-3">
              <ValidationProvider 
                name="Golongan Darah" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  Golongan Darah
                </div>

                <v-select
                  v-on:keyup.enter="save()"
                  
                  filled
                  rounded
                  dense

                  :color="set_color"
                  placeholder="Contoh. B"

                  hide-details

                  :items="['O', 'A', 'B', 'AB']"
                  :item-color="set_color"

                  v-model="form.blood_group"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        {{ errors[0] }}
                      </v-tooltip>
                    </div>
                    
                    <div v-if="form.blood_group !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
          </v-row>

          <div
            class="mb-6">
            <ValidationProvider 
              name="Alamat" 
              rules="required" 
              v-slot="{ errors, valid }">
              <div class="body-2 mb-2">
                <span class="red--text">*</span>
                Alamat
              </div>

              <v-textarea
                v-on:keyup.enter="save()"
                
                filled
                rounded
                dense
                rows="5"

                :color="set_color"
                placeholder="Contoh. Tuliskan alamat disini . . ."

                hide-details

                v-model="form.address"
                :success="form.address !== '' && valid"
                :error-messages="errors"
                style="border-radius: 10px;">
                <template v-slot:append-outer>
                  <div v-if="errors.length > 0">
                    <v-tooltip top color="#ff5252">
                      <template v-slot:activator="{ on }">
                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                      </template>
                      
                      {{ errors[0] }}
                    </v-tooltip>
                  </div>
                  
                  <div v-if="form.address !== '' && valid">
                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                  </div>
                </template>
              </v-textarea>
            </ValidationProvider>
          </div>

          <v-divider
            class="my-4"
            style="border-top: 2px dashed #EBEBEB;" />


          <v-row>
            <v-col
              cols="12"
              md="4">
              <ValidationProvider
                name="Shift" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  Shift
                </div>

                <v-select
                  v-on:keyup.enter="save()"
                  
                  filled
                  rounded
                  dense

                  :color="set_color"
                  placeholder="Contoh. Shift Pagi"

                  hide-details

                  :items="shift"
                  item-value="id"
                  item-text="name"
                  :item-color="set_color"
                  
                  clearable
                  @click:clear="form.shift_id = ''"

                  v-model="form.shift_id"
                  :success="form.shift_id !== '' && form.shift_id !== null && valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.shift_id !== '' && form.shift_id !== null && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>

            <v-col
              cols="12"
              md="4">
              <div>
                <div 
                  class="body-2 mb-2">
                  Jam Presensi Datang
                </div>

                <v-menu
                  ref="start_time"
                  v-model="time.start"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="form.presensi_start_time"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <ValidationProvider 
                      name="Jam Presensi Datang" 
                      v-slot="{ errors, valid }">
                      <v-text-field
                        v-on:keyup.enter="save"

                        readonly
                        filled
                        rounded
                        dense

                        :color="set_color"
                        placeholder="Contoh. 08:00"

                        hide-details

                        clearable
                        @click:clear="form.presensi_start_time = ''; form.presensi_end_time = '';"
                        v-on="on"
                        v-bind="attrs"

                        v-model="form.presensi_start_time"
                        :success="form.presensi_start_time !== '' && form.presensi_start_time !== null && valid"
                        :error-messages="errors"
                        required
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.presensi_start_time !== '' && form.presensi_start_time !== null && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </template>

                  <v-time-picker
                    v-if="time.start"
                    v-model="form.presensi_start_time"
                    full-width
                    :color="set_color"
                    format="24hr"
                    @click:minute="$refs.start_time.save(`${form.presensi_start_time}`); form.presensi_end_time = '';">
                  </v-time-picker>
                </v-menu>
              </div>
            </v-col>

            <v-col
              cols="12"
              md="4">
              <div>
                <div 
                  class="body-2 mb-2">
                  Jam Presensi Pulang
                </div>
                
                <v-menu
                  ref="end_time"
                  v-model="time.end"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="form.presensi_end_time"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <ValidationProvider 
                      name="Jam Presensi Pulang" 
                      v-slot="{ errors, valid }">
                      <v-text-field
                        v-on:keyup.enter="save"

                        readonly
                        filled
                        rounded
                        dense

                        :color="set_color"
                        placeholder="Contoh. 17:00"
                        
                        hide-details

                        clearable
                        @click:clear="form.presensi_end_time = ''"
                        v-on="on"
                        v-bind="attrs"

                        v-model="form.presensi_end_time"
                        :success="form.presensi_end_time !== '' && form.presensi_end_time !== null && valid"
                        :error-messages="errors"
                        required
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.presensi_end_time !== '' && form.presensi_end_time !== null && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </template>

                  <v-time-picker
                    v-if="time.end"
                    :min="form.presensi_start_time"
                    v-model="form.presensi_end_time"
                    full-width
                    :color="set_color"
                    format="24hr"
                    @click:minute="$refs.end_time.save(`${form.presensi_end_time}`)">
                  </v-time-picker>
                </v-menu>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
              md="6">
              <div>
                <div 
                  class="body-2 mb-2">
                  <span class="red--text">*</span>

                  Bergabung Tanggal
                </div>

                <v-menu
                  ref="join"
                  min-width="290px"
                  max-width="290px"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  :close-on-content-click="false"
                  v-model="picker.join">
                  <template v-slot:activator="{ on, attrs }">
                    <ValidationProvider 
                      name="Bergabung Tanggal" 
                      rules="required"
                      v-slot="{ errors, valid }">
                      <v-text-field
                        v-on:keyup.enter="save()"
                        
                        readonly
                        filled
                        rounded
                        dense

                        :color="set_color"
                        placeholder="Contoh. 2023-12-01"

                        hide-details

                        clearable
                        @click:clear="form.join_date = ''"

                        v-on="on"
                        v-bind="attrs"

                        v-model="form.join_date"
                        :success="form.join_date !== '' && valid"
                        :error-messages="errors"
                        required
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.join_date !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </template>

                  <v-date-picker 
                    :color="set_color"
                    v-model="form.join_date"
                    @input="picker.join = false">
                  </v-date-picker>
                </v-menu>
              </div>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    props: {
      form: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        shift: [],

        picker: {
          birthdate: false
        },

        time: {
          start: false,
          end: false
        }
      }
    },
    components: {
      
    },
    watch: {
      'form.shift_id': function() {
        let self = this
        let data = this.shift.filter(function(v) {
          return self.form.shift_id == v.id
        })

        if (data.length > 0) {
          this.form.presensi_start_time = data[0].start_time
          this.form.presensi_end_time = data[0].end_time
        }
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchShift()
    },
    methods: {
      async fetchShift () {
        let params = {
          limit: 100000
        }

        await get('admin/user_shift/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.shift = res.results.data
          }
        })
      },
    }
  }
</script>